<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"

  type RowSelectOption = {
    value: string
    label?: string
    name?: string
    disabled?: boolean
    tooltip?: string | null
    tooltipContent?: string | null
    description?: string | null
    dataTestid?: string
  }

  let {
    value = $bindable<string | null>(""),
    options = [],
    disabled = false,
    ariaLabel = undefined,
    placeholder = "Auswahl",
    classList = "inbox-table-control",
    selectStyle = "width: 100%; min-width: 0;",
    brightBackground = true,
    surfaceTone = "light",
    onChange,
  }: {
    value?: string | null
    options?: RowSelectOption[]
    disabled?: boolean
    ariaLabel?: string
    placeholder?: string
    classList?: string
    selectStyle?: string
    brightBackground?: boolean
    surfaceTone?: "auto" | "light" | "dark"
    onChange: (value: string) => void
  } = $props()

  const selectOptions = $derived(
    options.map((option) => ({
      value: option.value,
      label: option.label ?? option.name ?? option.value,
      name: option.name ?? option.label ?? option.value,
      ...(option.disabled ? { selectable: false } : {}),
      description: option.description ?? option.tooltipContent ?? option.tooltip ?? undefined,
      dataTestid: option.dataTestid,
    })),
  )
  const optionValues = $derived(new Set(options.map((option) => option.value)))

  const stringFromSelection = (input: unknown): string => {
    if (typeof input === "string" || typeof input === "number") return String(input)

    if (input && typeof input === "object" && "value" in input) {
      const nested = (input as { value?: unknown }).value

      if (typeof nested === "string" || typeof nested === "number") return String(nested)
    }

    return ""
  }

  const applyValue = (next: string) => {
    if (!optionValues.has(next)) return

    value = next
    onChange(next)
  }

  const handleValueChange = (nextValue: unknown) => {
    applyValue(stringFromSelection(nextValue))
  }
</script>

<Input
  type="select"
  {placeholder}
  label={ariaLabel ?? placeholder}
  labelVisibility="hidden"
  bind:value
  options={selectOptions}
  {disabled}
  {brightBackground}
  {surfaceTone}
  {classList}
  {selectStyle}
  onValueChange={handleValueChange}
/>
